import {
  Dumbbell,
  CreditCard,
  CupSoda,
} from "lucide-react";

import { motion } from "framer-motion";

import "../styles/howitworks.css";

const steps = [
  {
    icon: <Dumbbell size={34} />,
    title: "Select Your Protein",
    desc: "Choose your preferred flavor, nutrition blend and serving size from the smart vending interface.",
  },
  {
    icon: <CreditCard size={34} />,
    title: "Pay Digitally",
    desc: "Use QR, NFC, Apple Pay or cards for a seamless and secure checkout experience.",
  },
  {
    icon: <CupSoda size={34} />,
    title: "Enjoy Fresh Shake",
    desc: "Your shake is freshly prepared instantly with precision nutrition technology.",
  },
];

const HowItWorks = () => {
  return (
    <section id="works" className="journey">

      <div className="journey-glow"></div>

      <div className="journey-header">

        <span>HOW IT WORKS</span>

        <h2>
          Your Protein
          <br />
          Journey Starts Here
        </h2>

        <p>
          From selection to serving,
          OrangeCape creates a frictionless
          smart nutrition experience.
        </p>

      </div>

      <div className="timeline">

        {steps.map((step, index) => (

          <motion.div
            className={`timeline-item ${
              index % 2 === 0 ? "left" : "right"
            }`}
            key={index}
            initial={{ opacity:0, y:60 }}
            whileInView={{ opacity:1, y:0 }}
            transition={{ duration:0.6 }}
            viewport={{ once:true }}
          >

            <div className="timeline-content">

              <div className="timeline-icon">
                {step.icon}
              </div>

              <div className="timeline-number">
                0{index + 1}
              </div>

              <h3>{step.title}</h3>

              <p>{step.desc}</p>

            </div>

          </motion.div>

        ))}

        <div className="timeline-line"></div>

      </div>

    </section>
  );
};

export default HowItWorks;